(function() {
'use strict';

angular
    .module('TR')
    .service('multiSectorSearchValidator', multiSectorSearchValidator);

function multiSectorSearchValidator(dateUtil) {
    const service = {
        validate
    };

    function validate(legs) {
        const errors = [];

        const minLegs = 2;
        const maxLegs = 8;
        const minDiffDate = 1;

        if (legs.length < minLegs) {
            errors.push('Not enough legs');
        } else if (legs.length > maxLegs) {
            errors.push('Too many legs');
        }

        legs.forEach((leg, i) => {
            [leg.DepartureAirport, leg.DestinationAirport].forEach((airport, j) => {
                if (airport == null || typeof airport !== 'object' || !airport.Code) {
                    errors.push(`Leg ${i + 1}: Please select a ${j ? 'destination' : 'departure'} airport`);
                } else if (airport.Code.indexOf(',') !== -1) {
                    errors.push(`Leg ${i + 1}: Group airports are not supported`);
                }
            });

            if (i !== 0) {
                const date1 = dateUtil.parseDate(legs[i - 1].DepartureDate);
                const date2 = dateUtil.parseDate(leg.DepartureDate);
                const diff = dateUtil.getDifferenceInDays(date1, date2);
                if (diff < minDiffDate) {
                    errors.push('Flights must happen at least 1 day apart.');
                }
            }
        });

        return errors;
    }

    return service;
}
})();
